<template>
  <div>
    <CompanyHeader :img_header="header_image" header="ตั้งค่าข้อมูลบริษัท" link_back="managewebsite"/>
    <MenuCompany/>
    <Branch_information/>
  </div>
</template>

<script>
import CompanyHeader from "@/components/admin/manage_website/company_setting/menu_company/CompanyHeader";
import HeaderImage from "@/assets/process.png";
import MenuCompany from "@/components/admin/manage_website/company_setting/menu_company/MenuCompany";
import Branch_information from "@/components/admin/manage_website/company_setting/Branch_information";
export default {
  name: "BranchInformation",
  components: {
    Branch_information,
    MenuCompany,
    CompanyHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
